import React from 'react';
import { AppStore } from './../Core/AppStore';
import { Storage } from './../Core/Storage';
import { CartProvider } from './../Providers/CartProvider';
import { Routes } from './../Core/Constants'


export default class CartHeader extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	componentDidMount = () => {

		AppStore.on("Cart.AfterUpdate", () => {
			this.forceUpdate();
		});
		CartProvider.validateCart();
	}

	getCount = (items) => {
		let count = 0;
		items.forEach((item) => {
			count = count + item.count;
		});
		return count;
	}

	render() {
		let cart = Storage.instance().cachedCart;
		var T = window.Texts.cart;
		if (cart && cart.cartedProducts.length > 0) {
			return (
				<a href={Routes.Cart} id="header_cart" className="box cart not-empty" >
					<div className="count">
						{this.getCount(cart.cartedProducts)}
					</div>
					<span>{T.cartHeader}: {cart.priceTable.displayTotalPriceInclVat}</span>
				</a>);
		}
		else {
			return (
				<a href="#" id="header_cart" className="box cart empty">
					<span>{T.cartHeader + ' ' + T.emtyCartHeader}</span>
				</a>);
		}
	}
}

//inicializace 
var elements = document.querySelectorAll("[data-role='app-cart-header']");
if (elements.length > 0) {
	elements.forEach(function (element) {
		if (element) {
			var temp = document.createElement("div");
			var container = element.parentNode;
			ReactDOM.render(<CartHeader />, temp);
			// and replace the child
			container.replaceChild(temp.childNodes[0], element);
		}
	})
}





